// extracted by mini-css-extract-plugin
module.exports = {"image":"_02712f2b3b--image--AyX9T"};